module.exports = __webpack_public_path__ + "static/img/02@2x.274e510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/02@2x.png
// module id = vGE5
// module chunks = 1